import type { ReactNode } from "react";
import { AuthProvider } from "../../features/auth/AuthProvider";
import { ToastProvider } from "../../components/feedback/ToastProvider";
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <ToastProvider>{children}</ToastProvider>
    </AuthProvider>
  );
}
